import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AppConfig } from '../../../app.settings';
import { Company } from '../../models/entities/company.type';
import { Machine } from '../../models/entities/machine.type';
import { UpdateAccountViewModel } from '../../models/view-models/account-models/user-models/update-account-view-model';
import { RegisterAccountViewModel } from '../../models/view-models/account-models/user-models/register-account-view-model.type';
import { DisplayAccountViewModel } from '../../models/view-models/account-models/user-models/display-account-view-model.type';
import { ChangeUserStatus } from '../../models/view-models/account-models/user-models/change-user-status.model';


@Injectable()
export class AdministrationService {

  endpoint: string;

  private get headers(): HttpHeaders {
    return new HttpHeaders({ 'Content-Type': 'application/json' });
  }

  constructor(public http: HttpClient, public config: AppConfig) {
    this.endpoint = this.config.getConfig('api') + 'Admin/';
  }


  getAllCompanies(): Observable<Company[]> {
    return this.http.get<Company[]>(this.endpoint + 'AdminUtils/GetCompanies', {
      headers: this.headers
    });
  }

  getAllMachines(): Observable<Machine[]> {
    return this.http.get<Machine[]>(this.endpoint + 'AdminUtils/GetMachines', {
      headers: this.headers
    });
  }

  registerUser(user: RegisterAccountViewModel): Observable<DisplayAccountViewModel> {
    return this.http.post<DisplayAccountViewModel>(this.endpoint + 'AccountManagement/RegisterUser', user, {
      headers: this.headers
    });
  }

  updateUser(user: UpdateAccountViewModel): Observable<DisplayAccountViewModel> {
    return this.http.put<DisplayAccountViewModel>(this.endpoint + 'AccountManagement/UpdateUser', user, {
      headers: this.headers
    });
  }

  updateUserStatus(status: ChangeUserStatus): Observable<DisplayAccountViewModel> {
    return this.http.put<DisplayAccountViewModel>(this.endpoint + 'AccountManagement/ChangeStatus', status, {
      headers: this.headers
    });
  }

  deleteUser(id: string): Observable<void> {
    const urlFull = this.endpoint + 'AccountManagement/DeleteAccount/' + id;
    return this.http.delete<void>(urlFull, {
      headers: this.headers
    });
  }

  getUser(id: string): Observable<DisplayAccountViewModel> {
    return this.http.get<DisplayAccountViewModel>(this.endpoint + 'AccountManagement/GetUser/' + id, {
      headers: this.headers
    });
  }

  getUsersByCompany(): Observable<DisplayAccountViewModel[]> {
    return this.http.get<DisplayAccountViewModel[]>(this.endpoint + 'AccountManagement/GetUsersByCompany', {
      headers: this.headers
    });
  }

  getUsersByCategoryManager(): Observable<DisplayAccountViewModel[]> {
    return this.http.get<DisplayAccountViewModel[]>(this.endpoint + 'AccountManagement/GetUsersByCategoryManager');
  }
}
